// Other Pages
// 	Previously used for GAP Logo Contest but not anymore
// As of 02/06/2020 it is reused. -Rengie
// !function(t){t(document).ready(function(){"/pages/win"==location.pathname&&("#submitted"==window.location.hash&&(t(".entry-submitted-main").fadeIn(1e3),setTimeout(function(){t(".entry-submitted-main").fadeOut(1e3)},3e3),t("#lc-submit-over").click(function(){t(".entry-submitted-main").fadeOut(1e3)})));t("#lc-form-boverlay").click(function(){t(".lc-signup-cont").fadeOut(500)}),t(".unique-submit-trigger").click(function(){t(".lc-signup-cont").fadeIn(500)}),t("#sf-logo-closebtn, #sf-logo-closebtn2").click(function(){t(".lc-signup-cont").fadeOut(500),t(".entry-submitted-main").fadeOut(500)}),t("#input_4").focusout(function(){var n=t(this);n.val()?(n.css("background-color","#fff"),console.log("not empty")):(n.css("background-color","transparent"),console.log("empty"))}),t(".unique-share-block").click(function(n){n.preventDefault(),t(this).siblings().toggleClass("untoggled")}),t(".lc-entries.flexer .answer-block").click(function(n){t(this).toggleClass("drop").closest(".lc-entries").toggleClass("drop")})})}(jQuery);







// Raw copy of the code
(function($){
  $(document).ready(function(){
    const customer = $("#customer-check").data('logged');

    if(location.pathname == "/pages/stylestar"){
      var urlHash = window.location.hash;

      // if(urlHash == "#submitted"){
      //   $(".entry-submitted-main").fadeIn(1000)
      //   setTimeout(function(){$(".entry-submitted-main").fadeOut(1000)}, 3000)

      //   $('#lc-submit-over').click(function(){
      //     $(".entry-submitted-main").fadeOut(1000)
      //   })
      // }      
      if(urlHash == "#hp" && customer){
        $(".lc-signup-cont").fadeIn(500)
      }
    }

    //hide form by clicking black overlay
    $("#lc-form-boverlay").click(function(){
      $(".lc-signup-cont").fadeOut(500)
    })

    //button to display hidden form
    $('.unique-submit-trigger').click(function(){
      if(!customer){
        alert('Please LOGIN or SIGN IN to join.')
      } else{
        $(".lc-signup-cont").fadeIn(500)
      }
    })  

    //close button to close form
    $("#sf-logo-closebtn, #sf-logo-closebtn2").click(function(){
      $(".lc-signup-cont").fadeOut(500)
      $(".entry-submitted-main").fadeOut(500)
    })


    $('#input_4').focusout(function(){
      var $this = $(this)
      if($this.val()){
        $this.css('background-color', '#fff')
        console.log('not empty')
      } else {
        $this.css('background-color', 'transparent')
        console.log('empty') 
      }
    })

    $('.unique-share-block').click(function(e){
      e.preventDefault();

      var $this = $(this),
          $sibling = $this.siblings()

      $sibling.toggleClass('untoggled')


    })
    $('.lc-entries.flexer .answer-block').click(function(e){
      var $this = $(this)

      $this.toggleClass('drop').closest('.lc-entries').toggleClass('drop')
      //$this.closest('.lc-entries').toggleClass('drop')
    })
    $("#cid_14 .sss-button").click(function(){
        var $this = $(this),
            $parent = $this.closest("#cid_14"),
            $uploadList = $parent.find(".qq-upload-list"),
            $inputFile = $this.siblings();

           $inputFile.trigger("click")

           $inputFile.change(function(){
               var fileName = $inputFile.val();

                if($inputFile.val()){
  
                  if (fileName.substring(3,11) == 'fakepath') {
                      fileName = fileName.substring(12);
                  }

                  $uploadList.text(fileName)
                  $uploadList.removeClass('error')
                } else {
                  $uploadList.text('No File Selected*')
                }
            console.log(fileName);
           })
    })
    $("#sss_checkbox_agree").click(function(){
        $(this).toggleClass("checked").removeClass('error');
        
    })
    $(".jotform-form.sss-form").submit(function(e){
      e.preventDefault() // avoid to execute the actual submit of the form.
        var $this = $(this),
            sssCheckbox =  $("#sss_checkbox_agree"),
            sssChecker = $(this).find('.sss-check'),
            validCount = 0;
        const _url = $this.prop('action'); // the script where you handle the form input.
        const _data = new FormData($this[0]); // the script where you get all input data

        sssChecker.each(function(index){
          var sssData = $(this),
              sssFile = sssData.hasClass('form-submit-button-wood') ? true : false;
          if(!sssData.val()){
            sssData.addClass('error');
            if(sssFile){$('.qq-upload-list').addClass('error')}
            validCount++
          }
        });

        if(!customer){
          alert('Please login first to submit your entry.');
          return
        }
        else if(!sssCheckbox.hasClass("checked")){
          alert('Please read and agree to the COPYRIGHT WAIVER, CONSENT FORM & PRIVACY POLICY before proceeding.');
        } 
        else if(validCount == 0){
        //  alert('form complete')
          $.ajax({
            url: _url,
            type: "POST",
            processData: false,
            contentType: false,
            data: _data,
            success: function(data, status){
              console.log(status)
              console.log('Form submittied!!');
              $(".entry-submitted-main").fadeIn(1000)
              setTimeout(function(){$(".entry-submitted-main").fadeOut(1000); $(".lc-signup-cont").fadeOut(500)}, 3000)
              $this[0].reset;
            }
          })
        }
    })
    
    $('#click-banner .click_cont').click(function(){
      	const $this = $(this),
              $sibling = $this.siblings();
      
    		$this.toggleClass('on_top')  		
            
            $sibling.toggleClass('on_top')
            
//         if($this.classList.contains('on_top')){
//             $this.classList.remove('on_top')
//             $this.classList.add('on_bottom')
            
            
//             $sibling.classList.remove('on_bottom')
//             $sibling.classList.add('on_top')
//         } else if($this.classList.contains('on_bottom')){
//             $this.classList.remove('on_bottom')
//             $this.classList.add('on_top')
            
            
//             $sibling.classList.remove('on_top')
//             $sibling.classList.add('on_bottom')
//         }
    })
    $('.drop-btn').click(function(){
      var $this = $(this),
          $icon = $this.find(".drop-icon"),
          $list = $this.next(),
          $container = $this.closest('.dropdown-design');

      if($icon.hasClass("off-drop")){
        $icon.removeClass("off-drop").text($icon.text().replace("+", "-"))
        $list.css("max-height", 800)
        
        if($(window).width() > 768){
          $container.css("transform", 'translateY(-40%)');
        }
        
      } else{
        $icon.addClass("off-drop").text($icon.text().replace("-", "+"))
        $list.css("max-height", 0)
        $container.css("transform", 'none');
      }
    })
  })
})(jQuery)